import * as go from 'gojs';
import { toggleTextOnTextEditing } from '../../../../../utils/toggle-text-on-text-editing';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { startTextEditing } from '../../common/utils/start-text-editing';
import { textNodeTemplate } from '../text-node';
import { TEXT_COLOR_PROP } from './../../common/config/common-prop-names';

export const setupTextNode = (diagram: go.Diagram, categoryName: string) => {
  registerNodeTemplate(diagram, categoryName, textNodeTemplate());
  toggleTextOnTextEditing(diagram, categoryName, TEXT_COLOR_PROP);
  return registerDiagramListeners(diagram, categoryName);
};

const registerDiagramListeners = (diagram: go.Diagram, categoryName: string) => {
  const onExternalObjectsDropped = editTextOnDrop(categoryName);
  const onTextEdited = removeNodeWhenTextEmpty(categoryName);

  diagram.addDiagramListener('ExternalObjectsDropped', onExternalObjectsDropped);
  diagram.addDiagramListener('TextEdited', onTextEdited);

  return () => {
    diagram.removeDiagramListener('ExternalObjectsDropped', onExternalObjectsDropped);
    diagram.removeDiagramListener('TextEdited', onTextEdited);
  };
};

const editTextOnDrop = (categoryName: string) => async (e: go.DiagramEvent) => {
  const node = e.subject.first();
  if (node.category === categoryName) {
    await startTextEditing(e.diagram, node);
  }
};

const removeNodeWhenTextEmpty = (categoryName: string) => (e: go.DiagramEvent) => {
  const node = e.subject.part;
  if (node && node.category === categoryName && e.subject.text.trim() === '') {
    e.diagram.clearSelection();
    e.diagram.commit(() => e.diagram.model.removeNodeData(node.data));
  }
};
